import React from 'react'
import { TargetTypeIcon } from '../../../components'
import { WemoloTypography } from '../../../components/Wemolo'
import type { EditPayload, ExecutePayload } from '../changelog'
import styles from './ChangeLogItem.module.css'
import { EditDetails } from './EditDetails'
import { ExecuteDetails } from './ExecuteDetails'

interface ChangeLogItemProps {
    isLast: boolean
    targetType: 'lot' | 'station' | 'device'
    operation: 'edit' | 'execute'
    deviceType?: string
    actionType?: 'force_update' | 'sms'
    actor: { display: string; tooltip: string | null }
    actorTooltipVisible: boolean
    onActorMouseEnter: () => void
    onActorMouseLeave: () => void
    summaryNode: React.ReactNode
    relativeTime: string
    absoluteTime: string
    timestampTooltipVisible: boolean
    onTimestampMouseEnter: () => void
    onTimestampMouseLeave: () => void
    editPayload?: EditPayload
    executePayload?: ExecutePayload
    hiddenCount?: number
    onToggleExpand?: () => void
}

export const ChangeLogItem = ({
    isLast,
    targetType,
    operation,
    deviceType,
    actionType,
    actor,
    actorTooltipVisible,
    onActorMouseEnter,
    onActorMouseLeave,
    summaryNode,
    relativeTime,
    absoluteTime,
    timestampTooltipVisible,
    onTimestampMouseEnter,
    onTimestampMouseLeave,
    editPayload,
    executePayload,
    hiddenCount,
    onToggleExpand
}: ChangeLogItemProps) => {
    return (
        <div className={styles.item}>
            <div className={styles.left}>
                <TargetTypeIcon
                    type={targetType}
                    deviceType={deviceType}
                    operation={operation}
                    actionType={actionType}
                />
                {!isLast && <div className={styles.timeline} />}
            </div>

            <div className={isLast ? styles.contentLast : styles.content}>
                <div className={styles.summaryRow}>
                    <span className={styles.actorWrapper}>
                        <WemoloTypography variant="title-small" tag="span" className={styles.actorName}>
                            <b onMouseEnter={onActorMouseEnter} onMouseLeave={onActorMouseLeave}>
                                {actor.display}
                            </b>
                        </WemoloTypography>
                        {actorTooltipVisible && actor.tooltip && (
                            <WemoloTypography variant="label-xsmall" tag="span" className={styles.actorTooltip}>
                                {actor.tooltip}
                            </WemoloTypography>
                        )}
                    </span>
                    <WemoloTypography variant="body-small" tag="span" className={styles.summaryText}>
                        {summaryNode}
                    </WemoloTypography>
                    <div className={styles.timestampWrapper}>
                        <WemoloTypography variant="label-xsmall" tag="span" className={styles.timestamp}>
                            <span onMouseEnter={onTimestampMouseEnter} onMouseLeave={onTimestampMouseLeave}>
                                {relativeTime}
                            </span>
                        </WemoloTypography>
                        {timestampTooltipVisible && (
                            <WemoloTypography variant="label-xsmall" tag="div" className={styles.timestampTooltip}>
                                {absoluteTime}
                            </WemoloTypography>
                        )}
                    </div>
                </div>

                {editPayload && (
                    <EditDetails payload={editPayload} hiddenCount={hiddenCount} onToggleExpand={onToggleExpand} />
                )}
                {executePayload && <ExecuteDetails payload={executePayload} />}
            </div>
        </div>
    )
}
